import { render, staticRenderFns } from "./GoogleOauthBtn.vue?vue&type=template&id=0aba2b3a&scoped=true&"
import script from "./GoogleOauthBtn.vue?vue&type=script&lang=js&"
export * from "./GoogleOauthBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoogleOauthBtn.vue?vue&type=style&index=0&id=0aba2b3a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aba2b3a",
  null
  
)

export default component.exports